import React from "react";

export const ResumenFinca = ({ finca }) => {
    if (!finca) return null;

    const datos = [
        { etiqueta: "Finca", valor: finca.nombre },
        { etiqueta: "Contacto", valor: finca.nombre_contacto },
        { etiqueta: "Propietario", valor: finca.propietario_nombre },
        { etiqueta: "Perfil", valor: finca.perfil_nombre },
    ];

    return (
        <div className="bitacora-fletes__resumen mt-4 mb-3">
            {datos.map((dato) => (
                <div className="bitacora-fletes__resumen-dato" key={dato.etiqueta}>
                    <label className="mb-0 pl-0">
                        {dato.etiqueta}
                    </label>
                    <span className="bitacora-fletes__resumen-valor">
                        {dato.valor ? dato.valor : "---"}
                    </span>
                </div>
            ))}
        </div>
    );
};
